<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <div id="my-table-id">
      <v-data-table :headers="headers" :items="salary_month_list" class="elevation-1 mytable" :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Salary Month</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-row dense>
            <v-col cols="12" sm="3" md="3">
              <!-- <v-btn
              color="success"
              outlined
              rounded
              v-if="salary_month_list.length != 0"
            >
              <download-excel
                class="mr-2 pb-3 pt-2"
                :data="salary_month_list"
                :fields="table_fields"
                worksheet="PayRoll_SalaryMonth"
                name="PayRoll_SalaryMonth.xls"
              >
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn> -->
              <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'SalaryMonth')"
                :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="mb-2 button" v-on="on">Add Salary Month</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.name" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: January,February'
                              : 'For example :: January,February'
                          " label="Name" :rules="[(v) => !!v || 'required']" rounded outlined dense>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field persistent-hint hint="Inclusive" placeholder="Inclusive" color="#0F2027"
                                v-model="editedItem.fromdate" outlined rounded dense label="From Date Date"
                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                :rules="[(v) => !!v || 'required']"></v-text-field>
                            </template>
                            <v-date-picker v-model="editedItem.fromdate" @input="menu1 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field persistent-hint hint="Inclusive" placeholder="Inclusive" color="#0F2027"
                                v-model="editedItem.todate" outlined rounded dense label="To Date"
                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                :rules="[(v) => !!v || 'required']">
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="editedItem.todate" @input="menu2 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.number_of_days" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 28/20/31'
                              : 'For example :: 28/20/31'
                          " label="Number Of Days" :rules="[(v) => !!v || 'required']" rounded outlined dense>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete dense v-model="editedItem.month_id" :items="month_list" label="Month"
                            item-text="name" item-value="id" single-line rounded outlined
                            :rules="[(v) => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete dense v-model="editedItem.year_id" :items="year_list" label="Year"
                            item-text="name" item-value="id" single-line rounded outlined
                            :rules="[(v) => !!v || 'required']"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-checkbox v-model="editedItem.isfreezed" color="success" label="Is Freezed?"></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-checkbox v-model="editedItem.ispartialsalaryapplicable" color="success"
                            label="Is Partial Salary?"></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-checkbox v-model="
                            editedItem.financial_last_month_for_extra_tax
                          " color="success" label="Is Last Month For Extra Tax?"></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isfreezed="{ item }">
          <span v-if="item.isfreezed">
            <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.ispartialsalaryapplicable="{ item }">
          <span v-if="item.ispartialsalaryapplicable">
            <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.financial_last_month_for_extra_tax="{ item }">
          <span v-if="item.financial_last_month_for_extra_tax">
            <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    valid: false,
    // extraBreadcrumbItems: [
    //   { text: "Salary Month", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    overlay: false,
    errorMsg: {
      castId: false,
    },
    menu1: false,
    menu2: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "From Date",
        align: "left",
        sortable: false,
        value: "fromdate",
      },
      {
        text: "To Date",
        align: "left",
        sortable: false,
        value: "todate",
      },
      {
        text: "No of Days",
        align: "left",
        sortable: false,
        value: "number_of_days",
      },
      {
        text: "Month",
        align: "left",
        sortable: false,
        value: "month_name",
      },
      {
        text: "Year",
        align: "left",
        sortable: false,
        value: "year_name",
      },
      {
        text: "Is Freezed?",
        align: "left",
        sortable: false,
        value: "isfreezed",
      },
      {
        text: "Partial Salary?",
        align: "left",
        sortable: false,
        value: "ispartialsalaryapplicable",
      },
      {
        text: "Last Month?",
        align: "left",
        sortable: false,
        value: "financial_last_month_for_extra_tax",
      },

      {
        text: "Is Active?",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      Name: "name",
      "From Date": "fromdate",
      "To Date": "todate",
      "No of Days": "number_of_days",
      Month: "month_name",
      Year: "year_name",
      "Is Freezed?": "isfreezed",
      "Partial Salary?": "ispartialsalaryapplicable",
      "Last Month?": "financial_last_month_for_extra_tax",
      "Is Active?": "isactive",
    },
    month_list: [],
    year_list: [],
    salary_month_list: [],
    editedIndex: -1,
    editedItem: {
      salaryMonthId: "",
      name: "",
      fromdate: "",
      todate: "",
      number_of_days: "",
      isfreezed: "",
      ispartialsalaryapplicable: "",
      is_partial_salary_done: "",
      financial_last_month_for_extra_tax: "",
      month_id: "",
      month_name: "",
      year_id: "",
      year_name: "",
      isActive: true,
    },
    defaultItem: {
      salaryMonthId: "",
      name: "",
      fromdate: "",
      todate: "",
      number_of_days: "",
      isfreezed: "",
      ispartialsalaryapplicable: "",
      is_partial_salary_done: "",
      financial_last_month_for_extra_tax: "",
      month_id: "",
      month_name: "",
      year_id: "",
      year_name: "",
      isActive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Salary Month" : "Edit Salary Month";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Name</th>
      <th>From Date</th>
      <th>To Date</th>
      <th>No of Days</th>
      <th>Month</th>
      <th>Year</th>
      <th>Is Freezed?</th>
      <th>Particular Salary?</th>
      <th>Last Month</th>
      <th>Is Active?</th>
      
    </tr>`;

  this.salary_month_list.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${item.name || ''}</td> 
        <td>${item.fromdate || ''}</td> 
        <td>${item.todate || ''}</td> 
        <td>${item.number_of_days || ''}</td> 
        <td>${item.month_name || ''}</td> 
        <td>${item.year_name || ''}</td> 
        <td>${item.isfreezed ? 'Yes' : 'No'}</td> 
        <td>${item.ispartialsalaryapplicable ? 'Yes' : 'No'}</td> 
        <td>${item.financial_last_month_for_extra_tax ? 'Yes' : 'No'}</td> 
        <td>${item.isActive ? 'Active' : 'Inactive'}</td> 
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/getSalaryMonthList")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.salary_month_list = res.data.salary_month_list;
              this.month_list = res.data.month_list;
              this.year_list = res.data.year_list;
              //window.alert(JSON.stringify(this.month_list))
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.salary_month_list.indexOf(item);
      this.dialog = true;
      this.editedItem.salaryMonthId = item.id;
      this.editedItem.name = item.name;
      this.editedItem.fromdate = item.fromdate;
      this.editedItem.todate = item.todate;
      this.editedItem.number_of_days = item.number_of_days;
      this.editedItem.isActive = item.isactive;
      this.editedItem.isfreezed = item.isfreezed;
      this.editedItem.ispartialsalaryapplicable =
        item.ispartialsalaryapplicable;
      this.editedItem.is_partial_salary_done = item.is_partial_salary_done;
      this.editedItem.financial_last_month_for_extra_tax =
        item.financial_last_month_for_extra_tax;
      this.editedItem.month_id = item.month_id;
      this.editedItem.month_name = item.month_name;
      this.editedItem.year_id = item.year_id;
      this.editedItem.year_name = item.year_name;
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      //window.alert(this.editedIndex)
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Payroll/editSalaryMonth", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "200") {
                this.showSnackbar(
                  "#4caf50",
                  "Salary Month Updated Successfully..."
                ); // show snackbar on success
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Salary Month Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        //window.alert(JSON.stringify(this.editedItem))
        axios
          .post("/Payroll/saveSalaryMonth", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "200") {
              this.showSnackbar(
                "#4caf50",
                "Salary Month Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Salary Month Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.salaryMonthId) {
        return true;
      } else {
        if (!this.editedItem.salaryMonthId) {
          this.errorMsg.castId = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>